import { KycSubServiceType } from '../_modules/customers/_models/kyc-account-data';
import { TypeOfConnection } from './customer.model';
import { ProjectType } from './projectDesignation.model';
export { feederBandOptions } from '../enums/feeder-band.enum';

export class MeterAssignment {
  id: number = 0;
  projectType: number | undefined;
  projectDesignationId: number | null = null;
  feederBands: number[] = [];
  serviceRequestTypes: number[] = [];
  meterTypes: number[] = [];
  organizationIds: number[] = [];
  isDisabled: boolean = false;
}

export const projectTypeOptions = [
  { id: ProjectType.MAP, name: 'MAP' },
  { id: ProjectType.NMAP, name: 'NMAP' },
  { id: ProjectType.KCG, name: 'KCG' },
];

export const serviceRequestTypeOptions = [
  { id: KycSubServiceType.PublicLoad, name: 'Public Load' },
  { id: KycSubServiceType.MeterReplacement, name: 'Meter Replacement' },
  { id: KycSubServiceType.Migration, name: 'Migration' },
  { id: KycSubServiceType.Separation, name: 'Separation' },
  { id: KycSubServiceType.PointLoadTransformer, name: 'PointLoad Transformer' },
  { id: KycSubServiceType.DedicatedFeeder, name: 'Dedicated Feeder' },
  { id: KycSubServiceType.NewService, name: 'New Service' },
  { id: KycSubServiceType.UpgradeToKcg, name: 'Upgrade To KCG' },
];

export const meterTypeOptions = [
  { id: TypeOfConnection.SinglePhase, name: 'Single Phase' },
  { id: TypeOfConnection.ThreePhase, name: 'Three Phase' },
];
